<template>
  <!-- 活动 -->
  <div v-if="total > 0">
    <div class="cont-huodong">
      <div class="left-right-content clearfix">
        <div class="c-left" v-loading="fullscreenLoading">
          <div
            class="active-item-one"
            v-for="(item, index) in activityList"
            :key="index"
          >
            <div class="act-time">活动时间：{{ item.showTime }}</div>
            <div class="act-infos">
              <div class="zpzj-tit">
                <router-link
                  :to="'/activities/matchs/detail?id=' + item.id +'&plate='+item.belongSection+ ''"
                  >{{ item.activityName }}</router-link
                >
              </div>
              <div class="zc-count clearfix">
                <!--            <i class="icon see"></i><span class="much">666</span>-->
                <!--            <i class="icon zan"></i><span class="much">666</span>-->
                <!--            <i class="icon fenxiang"></i><span class="much">666</span>-->
                <span class="date">{{ item.formatDateStr }}</span>
              </div>
              <router-link
                :to="'/activities/matchs/detail?id=' + item.id  +'&plate='+item.belongSection+ ''"
                class="act-zhuti-img"
              >
                <img :src="item.activityImage" alt="" />
                <div
                  class="act-zt jxz"
                  v-if="item.showStatus == '进行中'"
                ></div>
                <div
                  class="act-zt yjs"
                  v-if="item.showStatus == '已结束'"
                ></div>
              </router-link>
            </div>
          </div>
          <div class="pagintion-f">
            <el-pagination
              background
              @current-change="getActivityList"
              layout="prev, pager, next"
              :current-page="currentPage"
              :page-size="5"
              :total="total"
              :hide-on-single-page="true"
            >
            </el-pagination>
          </div>
        </div>
        <div class="c-right">
          <div class="one-item">
            <div class="one-title">
              投稿作品
            </div>
            <div class="works-list">
              <div>
                <router-link
                  :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
                  class="item"
                  v-for="(item, index) in productionList"
                  :key="index"
                >
                  <div class="work-img-f">
                    <img :src="item.productionCover" alt="" />
                  </div>
                  <div class="work-title">{{ item.productionName }}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="common-no-data">
    <img class="img" :src="require('@/assets/images/empty_img.png')" alt="" />
    <span class="words">抱歉！您访问的页面暂无数据</span>
  </div>
</template>

<script type="text/ecmascript-6">
  import productionApi from '@/api/productionBack'

  import { mapState } from "vuex";
  import updateTdk from "@/utils/tdk";
export default {
  components: {

  },
  data () {
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      userId:"",
      activityList:[],
      productionList:[],
      total:0,
      index:0,
      currentPage:1,
      fullscreenLoading: true,
    }
  },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },
  mounted() {


    this.isMounted = true;

    let userId=this.$route.query.userId;
    this.userId=userId;

    const alreadyIncremented = !!this.productionDetail;
    if (!alreadyIncremented) {
      this.fetchData().then(this.initData());
    } else {
      this.initData();
    }


  },
  methods: {
    fetchData(){
      return this.$store
              .dispatch("FETCH_USER_DETAIL", {
                id: this.$route.query.userId
              })
              .finally(() => {
                this.$loading(false);
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initData(){
      this.getActivityList(1);
      this.getProductionList(1);
      //this.getUserInfo();
    },
    setSeo(){
      this.headTitle = this.userDetail.userName+"参加的活动——人人动画网【官网】";
      this.headKeywords = this.userDetail.impressStr;
      this.headDesc =this.userDetail.userName+"参加的活动";
    },
    // getUserInfo(){
    //   let _this=this;
    //   _this.fullscreenLoading = true
    //   let url="/rrbi/userInfo/userInfo-one?userId="+this.userId+"&ti="+new Date().getMilliseconds();
    //   _this.$axios.get(url).then(function(result){
    //     document.title =result.data.response.userName+"参加的活动——人人动画网【官网】"
    //     document.querySelector('meta[name="description"]').setAttribute('content', result.data.response.userName+"参加的活动")
    //   })
    // },
    getActivityList(page){
      let startPage=page;
      this.currentPage=startPage;
      let _this=this;
      _this.fullscreenLoading = true
      let pageSize=5;
      let url="/rrbi/activity/activity-mine?creatorId="+_this.userId+"&page="+startPage+"&pageSize="+pageSize+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        _this.activityList=result.data.response.list;
        _this.total = result.data.response.total
        _this.fullscreenLoading = false
        _this.toTop()
      })
    },
    getProductionList(page){
      this.currentPage=page;
      let _this=this;
      _this.fullscreenLoading = true
      let isPrize=null;
      if(this.is_prize){
        isPrize=1;
      }
      let queryParam={
        creatorId:this.userId,
        pageSize:5,
        pageIndex:page,
        origins:4,
      }
      productionApi.pageList(queryParam).then(data => {
        _this.productionList = data.list
        _this.fullscreenLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
//@import "../../../assets/less/stylePublic.less";
</style>
